export const AllotModeEnum = {
	DIRECT: 'DIRECT', //0,
	OMNIBUS: 'OMNIBUS', //3,
	NOMINEE: 'NOMINEE', //5
};

export type AllotModeEnum = typeof AllotModeEnum[keyof typeof AllotModeEnum];


export const AllotTreatmentEnum = {
	DontAllot: 'DontAllot', //0,
	Buy: 'Buy', //2,
	Sell: 'Sell', //3
};

export type AllotTreatmentEnum = typeof AllotTreatmentEnum[keyof typeof AllotTreatmentEnum];


export const BasisClosure = {
	New: 'New', //-2,
	Open: 'Open', //-1,
	Closed: 'Closed', //0,
	InternalAudit: 'InternalAudit', //1,
	ExternalAudit: 'ExternalAudit', //2
};

export type BasisClosure = typeof BasisClosure[keyof typeof BasisClosure];


export const BulletType = {
	Manual: 'Manual', //0,
	FixedInterval: 'FixedInterval', //1,
	QuarterAlignment: 'QuarterAlignment', //2,
	SemiAnnualAlignment: 'SemiAnnualAlignment', //3,
	YearlyAlignment: 'YearlyAlignment', //4
};

export type BulletType = typeof BulletType[keyof typeof BulletType];


export const CurrencyCodes = {
	AED: 'AED',
	AUD: 'AUD',
	AWG: 'AWG',
	CAD: 'CAD',
	EGP: 'EGP',
	EUR: 'EUR',
	GBP: 'GBP',
	JPY: 'JPY',
	KWD: 'KWD',
	NGN: 'NGN',
	PEN: 'PEN',
	RSD: 'RSD',
	RUB: 'RUB',
	USD: 'USD',
	WAU: 'WAU',
	XXX: 'XXX',
	ZAR: 'ZAR',
	ZMK: 'ZMK',
	ZWD: 'ZWD',
};

export type CurrencyCodes = typeof CurrencyCodes[keyof typeof CurrencyCodes];


export const FAAssetClosure = {
	Pending: 'Pending', //-1,
	Acquired: 'Acquired', //0,
	DepreciatedFully: 'DepreciatedFully', //1,
	Disposed: 'Disposed', //2
};

export type FAAssetClosure = typeof FAAssetClosure[keyof typeof FAAssetClosure];


export const FAAssetType = {
	FixedAsset: 'FixedAsset', //1,
	IntangibleAsset: 'IntangibleAsset', //2
}

export type FAAssetType = typeof FAAssetType[keyof typeof FAAssetType];


export const FACashAcctTypeEnum = {
	None: 'None', //000,

	PettyCash: 'PettyCash', //_Cash, //011,
	VaultCash: 'VaultCash', //_Cash | _Vault, //012,

	BusCall: 'BusCall', //_Bank | _Business | _Call, //102,
	BusChecking: 'BusChecking', //_Bank | _Business | _Checking, //101,
	BusClearing: 'BusClearing', //_Bank | _Business | _Clearing, //112,
	BusCollateral: 'BusCollateral', //_Bank | _Business | _Collateral, //113,
	BusDomChecking: 'BusDomChecking', //_Bank | _Business | _Domicilliary | _Checking, //103,
	BusDomSavings: 'BusDomSavings', //_Bank | _Business | _Domicilliary | _Savings, //104,
	BusFxdDep: 'BusFxdDep', //_Bank | _Business | _FixedDeposit, //105,
	BusMerchant: 'BusMerchant', //_Bank | _Business | _Merchant, //111,
	BusSavings: 'BusSavings', //_Bank | _Business | _Savings, //106,

	ClientChecking: 'ClientChecking', //_Bank | _Client | _Checking, //201,
	ClientCall: 'ClientCall', //_Bank | _Client | _Call, //202,
	ClientDomChecking: 'ClientDomChecking', //_Bank | _Client | _Domicilliary | _Checking, //203,
	ClientDomSavings: 'ClientDomSavings', //_Bank | _Client | _Domicilliary | _Savings, //204,
	ClientFxdDep: 'ClientFxdDep', //_Bank | _Client | _FixedDeposit, //205,
	ClientSavings: 'ClientSavings', //_Bank | _Client | _Savings, //206,
};

export type FACashAcctTypeEnum = typeof FACashAcctTypeEnum[keyof typeof FACashAcctTypeEnum];

	
export const FACashDisburseBearer = {
	Self: 'Self', //0,
	Project: 'Project', //1,
	Partner: 'Partner', //2,
}

export type FACashDisburseBearer = typeof FACashDisburseBearer[keyof typeof FACashDisburseBearer];


export const FACategoryEnum = {
	NONE: 'NONE', //0,
	AGENT: 'AGENT', //10,             //Partner
	BANK: 'BANK', //20,
	CASH: 'CASH', //40,
	CUSTOMER: 'CUSTOMER', //50,          //Partner
	DEBT: 'DEBT', //60,
	INTERNAL: 'INTERNAL', //70,
	INVENTORY: 'INVENTORY', //80,
	INTERCOMPANY: 'INTERCOMPANY', //90,
	INVESTMENT: 'INVESTMENT', //100,
	MANUFACTURING: 'MANUFACTURING', //103,
	MARKETOPERATOR: 'MARKETOPERATOR', //108,	//Partner
	PREPAYMENT: 'PREPAYMENT', //110,
	RECOVERABLE: 'RECOVERABLE', //120,
	STAFF: 'STAFF', //140,            //Partner
	TRADING: 'TRADING', //145,
	VENDOR: 'VENDOR', //150            //Partner
};

export type FACategoryEnum = typeof FACategoryEnum[keyof typeof FACategoryEnum];


export const FACenterType = {
	Cost: 'Cost', //1,
	Profit: 'Profit', //2,
	Investment: 'Investment', //3
};

export type FACenterType = typeof FACenterType[keyof typeof FACenterType];


export const FAFinHouseClass = {
	CardIssuer: 'CardIssuer', //1,
	CardProcessor: 'CardProcessor', //2,
	CreditUnion: 'CreditUnion', //4,
	DiscountHouse: 'DiscountHouse', //6,
	Insurance: 'Insurance', //9,
	LocalBank: 'LocalBank', //12,
	MerchantBank: 'MerchantBank', //13,
	MicroFinance: 'MicroFinance', //15,
	MortgageBank: 'MortgageBank', //16,
	NationalBank: 'NationalBank', //18,
	RegionalBank: 'RegionalBank', //21,
};

export type FAFinHouseClass = typeof FAFinHouseClass[keyof typeof FAFinHouseClass];


/*** This enum indicating the various types of GlAccts */
export const FAGlTypeEnum = {
	//NONE: 0,
	/*** This indicates that the attached account is an ASSET */
	ASSET: 'ASSET', //1,
	/*** This indicates that the attached account is a LIABILITY */
	LIABILITY: 'LIABILITY', //2,
	/*** This indicates that the attached account is a PROVISION tracking account */
	PROVISION: 'PROVISION', //3,
	/*** This indicates that the attached account tracks Shareholders' funds */
	EQUITY: 'EQUITY', //4,
	/*** This indicates that the attached account is an INCOME account and therefore appears on the P&L as well as the OCI statement */
	INCOME: 'INCOME', //5,
	/*** This indicates that the attached account is an EXPENSE account and therefore appears on the P&L as well as the OCI statement */
	EXPENSE: 'EXPENSE', //6
	/*** This indicates that the attached account appears on the CI statement but is not mainstream INCOME or EXPENSE account */
	OCI: 'OCI', //7
};

export type FAGlTypeEnum = typeof FAGlTypeEnum[keyof typeof FAGlTypeEnum];


/*** This enum indicating the various types of Journals the system supports */
export const FAJrnlTypeEnum = {
	/*** Indicates a USER generated journal */
	USER: 'USER', //0,

	/*** Indicates a journal for auto-generated bank reconciliation entries */
	BANKRECON: 'BANKRECON', //1,

	/*** Indicates a journal with adjustment entries for an FABasis; it is user generated but with special rules for posting and general treatment */
	BASIS_AUDIT: 'BASIS_AUDIT', //11,
	/*** Indicates a system generated journal for FABasis closure. It moves Interest/Expense to appropriation */
	BASIS_CLOSING: 'BASIS_CLOSING', //12,
	/*** Indicates a system generated journal for FABasis opening */
	BASIS_OPENING: 'BASIS_OPENING', //13,
	/*** Indicates a system generated journal; generated for the archiving of FABasisPeriod's */
	BASIS_SUMMARY: 'BASIS_SUMMARY', //14,

	/*** Indicates a system journal generated when advancing cash to a staff for business operations */
	CASH_ADVANCE: 'CASH_ADVANCE', //21,
	/*** Indicates a system journal generated for the disbursement of funds in a CashBook */
	CASH_DISBURSE: 'CASH_DISBURSE', //22,
	/*** Indicates a system journal generated for the reimbursement of a CashBook */
	CASH_REIMBURSE: 'CASH_REIMBURSE', //23,
	/*** Indicates a system journal generated when retiring a cash advance given to a staff or when a cash claim is made */
	CASH_RETIRE: 'CASH_RETIRE', //24,

	CASH_SWAP: 'CASH_SWAP', //25,
	CASH_TRANSFER: 'CASH_TRANSFER', //26,

	CASH_REVALUE: 'CASH_REVALUE', //27,

	/*** Indicates a system journal generated for the processing of certificate deposits and the attached fees */
	CUST_CERTFEE: 'CUST_CERTFEE', //31,
	/*** Indicates a system journal generated for the processing of CSCS related transactions and the associated fees */
	CUST_CSCSFEE: 'CUST_CSCSFEE', //32,
	/*** Indicates a system journal generated for the processing of quarterly management fees */
	CUST_MGTFEE: 'CUST_MGTFEE', //33,
	/*** Indicates a system journal generated for the processing of transfer fees */
	CUST_XFERFEE: 'CUST_XFERFEE', //34,

	/*** Indicates a system journal generated for the posting of a Fund subscription */
	FUNDTRANS: 'FUNDTRANS', //41,

	/*** Indicates a system journal generated for the acquisition of a FixedAsset */
	FAASSET_ACQUIRE: 'FAASSET_ACQUIRE', //51,
	/*** Indicates a system journal generated during the monthly depreciation for FixedAssets */
	FAASSET_AMORT: 'FAASSET_AMORT', //52,
	/*** Indicates a system journal generated for the discarding of a FixedAsset */
	FAASSET_DISPOSE: 'FAASSET_DISPOSE', //53,
	/*** Indicates a system journal generated as part of the processing of a FixedAsset maintenance record */
	FAASSET_MAINTAIN: 'FAASSET_MAINTAIN', //54,

	/*** Indicates a system generated journal for the scheduled running of interest on FAGlAcct, tracked with PartnerInterestRun */
	INTEREST: 'INTEREST', //61,
	/*** Indicates a journal posted with the initial/opening balances when the system is first setup */
	OPENINGBALANCE: 'OPENINGBALANCE', //62,
	/*** Indicates a system generated journal for the scheduled run of a FAScheduleTran */
	ORDER: 'ORDER', //63,
	/*** Indicates a system generated journal for the initialization of a FASchedulePrepay */
	PREPAYMENT: 'PREPAYMENT', //64,

	/*** Indicates a system generated journal for the posting of a EQHoldingPryIssue */
	PRYISSUE_PAYMENT: 'PRYISSUE_PAYMENT', //71,
	/*** Indicates a system generated journal for the remittance of a PryIssue subscription funds */
	PRYISSUE_REMIT: 'PRYISSUE_REMIT', //72,

	/*** Indicates a system generated journal raised for the transfer of cash between partners */
	PTNR_CPRTY_TRANSFER: 'PTNR_CPRTY_TRANSFER', //73,
	/*** Indicates a system generated journal raised for the transfer of cash between partners */
	PTNR_OWN_TRANSFER: 'PTNR_OWN_TRANSFER', //74,
	/*** Indicates a system generated journal for the posting of a PartnerPayment */
	PTNR_PAYMENT: 'PTNR_PAYMENT', //75,
	/*** Indicates a system generated journal for the posting of a PartnerReceipt */
	PTNR_RECEIPT: 'PTNR_RECEIPT', //76,
	/*** Indicates a system generated journal for the posting of a subscription to PartnerWebService */
	PTNR_SUBSCRIPTION: 'PTNR_SUBSCRIPTION', //77,
	/*** Indicates a system generated journal for the posting of a EQWarrant */
	PTNR_WARRANT: 'PTNR_WARRANT', //78,
	/*** Indicates a system generated journal for the posting of a PurchaseInvoice */
	PTNR_PURCH_INVOICE: 'PTNR_PURCH_INVOICE', //79,
	/*** Indicates a system generated journal for the posting of a SaleInvoice */
	PTNR_SALE_INVOICE: 'PTNR_SALE_INVOICE', //80,

	/*** Indicates a system generated journal for posting accruals on a Treasury object */
	TI_ACCRUAL: 'TI_ACCRUAL', //81,
	/*** Indicates a system generated journal for disbursement/repayment made on a Treasury object */
	TI_PAYMENT: 'TI_PAYMENT', //82,
	/*** Indicates a system generated journal for posting provisions on a Treasury object */
	TI_PROVISION: 'TI_PROVISION', //83,
	/*** Indicates a system generated journal for writing off a Treasury object */
	TI_WRITEOFF: 'TI_WRITEOFF', //84,

	/*** Indicates a system generated journal for the posting of a trade contract (EQContractNote) */
	TRADE_CONTRACT: 'TRADE_CONTRACT', //91,  //this value is used in range query for CustomerLastActivity, do Shift+F12 to deal with new additions
	/*** Indicates a system generated journal for the settlement of trade contracts for a given EQDealSheet */
	TRADE_SETTLEMENT: 'TRADE_SETTLEMENT', //92
};

export type FAJrnlTypeEnum = typeof FAJrnlTypeEnum[keyof typeof FAJrnlTypeEnum];


export const FAReportTreatment = {
	//NONE: 0,
	Posting: 'Posting', //2,
	RollupFx: 'RollupFx', //4,
	Summary: 'Summary', //8
};

export type FAReportTreatment = typeof FAReportTreatment[keyof typeof FAReportTreatment];


export const FATransactionMethod = {
	CASH: 'CASH', //1,
	CHEQUE: 'CHEQUE', //2,
	DIRECT: 'DIRECT', //0,
	DRAFT: 'DRAFT', //3,
	DTF: 'DTF', //4,
	NEFT: 'NEFT', //5,
	NIBSS: 'NIBSS', //6,
	WARRANT: 'WARRANT', //7,
	CARD: 'CARD', //8
};

export type FATransactionMethod = typeof FATransactionMethod[keyof typeof FATransactionMethod];


export const FATransactionVerifierType = {
	None: 'None', //0,
	Processor: 'Processor', //1,
	Teller: 'Teller', //1,
};

export type FATransactionVerifierType = typeof FATransactionVerifierType[keyof typeof FATransactionVerifierType];


export const FinRateType = {
	Annualized: 'Annualized', //1,
	FixedRate: 'FixedRate', //2,
	Monthly: 'Monthly', //3,
}

export type FinRateType = typeof FinRateType[keyof typeof FinRateType];


export const FiTradeClosure = {
	Discarded: 'Discarded', //-2,
	Pending: 'Pending', //-1,

	ApprovedForDispatch: 'ApprovedForDispatch', //0, //Supervisor manually approves for dispatch pending matching and resolution
	//Matched: 'Matched', //1,
	Allotted: 'Allotted', //2,

	InitPending: 'InitPending', //3,

	Running: 'Running', //4,
	Terminated: 'Terminated', //5,
	RolledOver: 'RolledOver', //6
};

export type FiTradeClosure = typeof FiTradeClosure[keyof typeof FiTradeClosure];


export const FxHandlingTypeEnum = {
	NONE: 'NONE', //0,
	TRACK: 'TRACK', //1,
	TRADE: 'TRADE', //2,
	TRACK_TRADE: 'TRACK_TRADE', //TRACK | TRADE,
};

export type FxHandlingTypeEnum = typeof FxHandlingTypeEnum[keyof typeof FxHandlingTypeEnum];


export const GeneralApprovalClosure = {
	/**Indicates an Approval that has been invalidated*/
	Invalidated: 'Invalidated', //-10,
	/**Indicates an Approval that has been discarded*/
	Request_Invalidate: 'Request_Invalidate', //-7,
	/**Indicates an Approval that has failed; transaction will contain more relevant details*/
	Failed: 'Failed', //-5,
	/**Indicates an Approval that has been discarded*/
	Discarded: 'Discarded', //-2,
	/**Indicates a pending Approval on which no further operation has been carried out*/
	Pending: 'Pending', //-1,
	/**Indicates an Approval that is undergoing validation (say KYC)*/
	Validating: 'Validating', //0,
	/**Indicates an Approval that is awaiting EM approval*/
	Approving: 'Approving', //2,
	/**Indicates an Approval that is being implemented*/
	Implementing: 'Implementing', //3,
	/**Indicates an Approval that is done and dusted*/
	Done: 'Done', //4,
};

export type GeneralApprovalClosure = typeof GeneralApprovalClosure[keyof typeof GeneralApprovalClosure];


export const GeneralDataClosure = {
	Invalidated: 'Invalidated', //-2,
	Pending: 'Pending', //-1,
	Approved: 'Approved', //0
	Published: 'Published', //1
};

export type GeneralDataClosure = typeof GeneralDataClosure[keyof typeof GeneralDataClosure];


/// <summary>An enumeration used to indicate end-user supplying a valid Govt Id</summary>
export const GovIdProvisionEnum = {
	/// <summary>Status cannot be determined at this time</summary>
	Indeterminate: 'Indeterminate', //0,
	/// <summary>Indicates the partner provided the Id</summary>
	Given: 'Given', //10,
	/// <summary>Partner says none was issued</summary>
	NotIssued: 'NotIssued', //20,
	/// <summary>Partner has been unable to obtain Id</summary>
	NotObtained: 'NotObtained', //30,
	/// <summary>Partner may/may not have Id but is not required to disclose same</summary>
	NotRequired: 'NotRequired', //40,
};

export type GovIdProvisionEnum = typeof GovIdProvisionEnum[keyof typeof GovIdProvisionEnum];


export const ItemMeasure = {
	Count: 'Count', //0,
	Area: 'Area', //1,
	Length: 'Length', //2,
	Mass: 'Mass', //3,
	Volume: 'Volume', //4,
	Weight: 'Weight', //5
};

export type ItemMeasure = typeof ItemMeasure[keyof typeof ItemMeasure];


export const JournalClosure = {
	Gateway_ToTransact: 'Gateway_ToTransact', //-16,
	Gateway_ToConfirm: 'Gateway_ToConfirm', //-15,
	Invalidated: 'Invalidated', //-10,
	Request_Invalidate: 'Request_Invalidate', //-7,
	Failed: 'Failed', //-5,
	Discarded: 'Discarded', //-2,
	Pending: 'Pending', //-1,
	Validating: 'Validating', //0,
	Approving: 'Approving', //2,
	Closed: 'Closed', //4, // => 0
	Clearing: 'Clearing', //6, // => 1
	Posted: 'Posted', //7, // => 2
	Reversed: 'Reversed', //8, // => 3
	Archived: 'Archived', //10
};

export type JournalClosure = typeof JournalClosure[keyof typeof JournalClosure];


export const MoneyMarketCategory = {
	BOND: 'BOND', //1,
	COMMERCIAL_PAPER: 'COMMERCIAL_PAPER', //2,
	FIXED_DEPOSIT: 'FIXED_DEPOSIT', //3,
	INTERBANK: 'INTERBANK', //4,        //not for individuals but sets the tone for most other rates/investments
	TBILL: 'TBILL', //5,
	TERM_INSTRUMENT: 'TERM_INSTRUMENT', //6, //or TermDeposit
	SAVINGS_DEPOSIT: 'SAVINGS_DEPOSIT', //7,
};

export type MoneyMarketCategory = typeof MoneyMarketCategory[keyof typeof MoneyMarketCategory];


/** Enum indicating the manner in which a MoneyMkt investment is being exited */
export const MoneyMarketExit = {
	/** The default is to hold to maturity */
	Maturing: 'Maturing', //0,
	/** Indicates a decision to sell */
	Selling: 'Selling', //1,
};

export type MoneyMarketExit = typeof MoneyMarketExit[keyof typeof MoneyMarketExit];


export const MoneyMarketType = {
	FD_VAR: 'FD_VAR', //3000,
	FD_030: 'FD_030', //3030,
	FD_060: 'FD_060', //3060,
	FD_090: 'FD_090', //3090,
	FD_120: 'FD_120', //3120,
	FD_180: 'FD_180', //3180,
	FD_360: 'FD_360', //3360,

	INTERBANK_CALL: 'INTERBANK_CALL', //4000,
	INTERBANK_OBB: 'INTERBANK_OBB', //4001,
	INTERBANK_007: 'INTERBANK_007', //4007,
	INTERBANK_030: 'INTERBANK_030', //4030,
	INTERBANK_060: 'INTERBANK_060', //4060,
	INTERBANK_090: 'INTERBANK_090', //4090,
	INTERBANK_180: 'INTERBANK_180', //4180,
	INTERBANK_360: 'INTERBANK_360', //4360,

	TBILL_VAR: 'TBILL_VAR', //5000,
	TBILL_091: 'TBILL_091', //5091,
	TBILL_182: 'TBILL_182', //5182,
	TBILL_364: 'TBILL_364', //5364,
};

export type MoneyMarketType = typeof MoneyMarketType[keyof typeof MoneyMarketType];


export const MoneyMarketType_TBill = {
	TBILL_VAR: 'TBILL_VAR', //5000,
	TBILL_091: 'TBILL_091', //5091,
	TBILL_182: 'TBILL_182', //5182,
	TBILL_364: 'TBILL_364', //5364,
};

export type MoneyMarketType_TBill = typeof MoneyMarketType_TBill[keyof typeof MoneyMarketType_TBill];


/// <summary>Enum indicating the various stages of an Order's lifecycle</summary>
export const OrderClosure = {
	/// <summary>Indicates an order that has been killed</summary>
	KILLED: 'KILLED', //-100,
	/// <summary>Indicates a request to have the order killed irrespective of its fulfillment status</summary>
	REQUEST_KILL: 'REQUEST_KILL', //-50,
	/// <summary>Indicates a request to suspend the order</summary>
	REQUEST_SUSPEND: 'REQUEST_SUSPEND', //-40,
	/// <summary>Indicates a request to edit/change the parameters of the order</summary>
	REQUEST_EDIT: 'REQUEST_EDIT', //-30,
	/// <summary>Indicates an order that has failed</summary>
	FAILED: 'FAILED', //-10,
	/// <summary>Indicates an order that is pending and has not undergone any processing</summary>
	PENDING: 'PENDING', //-1,
	/// <summary>Indicates an order that has been received and acknowledgement passed on to the sender</summary>
	RECEIVED: 'RECEIVED', //0,
	/// <summary>Indicates and order going through the approval phase</summary>
	APPROVING: 'APPROVING', //1,
	/// <summary>Indicates that an order is executing</summary>
	EXECUTING: 'EXECUTING', //5,
	/// <summary>Indicates that an order has been filled</summary>
	FILLED: 'FILLED', //10
};

export type OrderClosure = typeof OrderClosure[keyof typeof OrderClosure];

// export const OrderValidationTranslateClosure
// {
// 	[EnumDescription("Kill requested")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.REQUEST_KILL,
// 		(int)Stale, (int)Killed)]
// 	KillRequested = -50,

// 	[EnumDescription("Suspend requested")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.REQUEST_SUSPEND,
// 		(int)KillRequested,
// 		(int)Stale, (int)AutoApproval, (int)ManualApproval, (int)Killed)]
// 	SuspendRequested = -20,

// 	[EnumDescription("Edit requested")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.REQUEST_EDIT,
// 		(int)SuspendRequested, (int)KillRequested,
// 		(int)Stale, (int)AutoApproval, (int)ManualApproval, (int)Killed)]
// 	EditRequested = -10,

// 	[EnumDescription("No validation done yet")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.PENDING,
// 		(int)KillRequested, (int)SuspendRequested, (int)EditRequested, (int)Suspended, (int)Stale, 
// 		(int)AutoApproval, (int)ManualApproval, (int)Killed, (int)InsufficientHolding, (int)LimitOutOfRange, (int)Unfunded, (int)Excluded, 
// 		(int)KycIncomplete, (int)LimitInvalid, (int)QuantityInvalid, (int)AccountInvalid)]
// 	NoneYet = 0,

// 	[EnumDescription("Auto Approved for trading")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.EXECUTING,
// 		(int)KillRequested, (int)SuspendRequested, (int)EditRequested, (int)Suspended, (int)Stale, 
// 		(int)ManualApproval, (int)Killed, (int)InsufficientHolding, (int)LimitOutOfRange, (int)Unfunded, (int)Excluded,
// 		(int)Matched, (int)Filled, (int)KycIncomplete, (int)LimitInvalid, (int)QuantityInvalid, (int)AccountInvalid)]
// 	AutoApproval = 1,

// 	[EnumDescription("Auto Approved for trading")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.EXECUTING,
// 		(int)KillRequested, (int)SuspendRequested, (int)EditRequested, (int)Suspended, (int)Stale,
// 		(int)Killed, (int)InsufficientHolding, (int)LimitOutOfRange, (int)Unfunded, (int)Excluded,
// 		(int)Matched, (int)Filled, (int)KycIncomplete, (int)LimitInvalid, (int)QuantityInvalid, (int)AccountInvalid)]
// 	ManualApproval = 2,

// 	[EnumDescription("Order suspended")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.EXECUTING,
// 		(int)KillRequested, (int)EditRequested, (int)Stale,
// 		(int)AutoApproval, (int)ManualApproval, (int)Killed, (int)InsufficientHolding, (int)LimitOutOfRange, (int)Unfunded, (int)Excluded,
// 		(int)Matched, (int)Filled, (int)KycIncomplete, (int)LimitInvalid, (int)QuantityInvalid, (int)AccountInvalid)]
// 	Suspended = 3,

// 	[EnumDescription("Order stale")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.FAILED)]
// 	Stale = 4,

// 	[EnumDescription("Order killed")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.KILLED)]
// 	Killed = 5,

// 	[EnumDescription("Insufficient holdings for sale")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.FAILED)]
// 	InsufficientHolding = 6,

// 	[EnumDescription("Order suspended")]
// 	[EnumStatus(false, false, false, false, (int)OrderClosure.EXECUTING,
// 		(int)KillRequested, (int)SuspendRequested, (int)EditRequested, (int)Suspended, (int)Stale,
// 		(int)AutoApproval, (int)ManualApproval, (int)Killed, (int)InsufficientHolding, (int)Unfunded, (int)Excluded,
// 		(int)Matched, (int)Filled, (int)KycIncomplete, (int)LimitInvalid, (int)QuantityInvalid, (int)AccountInvalid)]
// 	LimitOutOfRange = 7,

// 	[EnumDescription("Insufficient funds for purchase")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.FAILED)]
// 	Unfunded = 8,

// 	[EnumDescription("Portfolio exclusion rules")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.FAILED)]
// 	Excluded = 9,

// 	[EnumDescription("Order matched internally")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.FILLED)]
// 	Matched = 10,

// 	[EnumDescription("Order filled")]
// 	[EnumStatus(true, false, false, false, (int)OrderClosure.FILLED)]
// 	Filled = 11,

// 	[EnumDescription("Order failed KYC check")]
// 	[EnumStatus(true, true, false, false, (int)OrderClosure.FAILED)]
// 	KycIncomplete = 12,

// 	[EnumDescription("Invalid limit specified")]
// 	[EnumStatus(true, true, false, false, (int)OrderClosure.FAILED)]
// 	LimitInvalid = 13,

// 	[EnumDescription("Invalid quantity specified")]
// 	[EnumStatus(true, true, false, false, (int)OrderClosure.FAILED)]
// 	QuantityInvalid = 14,

// 	[EnumDescription("Invalid account specified")]
// 	[EnumStatus(true, true, false, false, (int)OrderClosure.FAILED)]
// 	AccountInvalid = 15,

// 	[EnumDescription("Invalid instrument specified")]
// 	[EnumStatus(true, true, false, false, (int)OrderClosure.FAILED)]
// 	InstrumentInvalid = 16
// };

export const OrderValidationEnum = {
	/** Kill requested */
	KillRequested: 'KillRequested', //-50,

	/** Suspend requested */
	SuspendRequested: 'SuspendRequested', //-20,

	/** Edit requested */
	EditRequested: 'EditRequested', //-10,

	/** No validation done yet */
	NoneYet: 'NoneYet', //0,

	/** Auto Approved for trading */
	AutoApproval: 'AutoApproval', //1,

	/** Auto Approved for trading */
	ManualApproval: 'ManualApproval', //2,

	/** Order suspended */
	Suspended: 'Suspended', //3,

	/** Order stale */
	Stale: 'Stale', //4,

	/** Order killed */
	Killed: 'Killed', //5,

	/** Insufficient holdings for sale */
	InsufficientHolding: 'InsufficientHolding', //6,

	/** Order suspended */
	LimitOutOfRange: 'LimitOutOfRange', //7,

	/** Insufficient funds for purchase */
	Unfunded: 'Unfunded', //8,

	/** Portfolio exclusion rules */
	Excluded: 'Excluded', //9,

	/** Order matched internally */
	Matched: 'Matched', //10,

	/** Order filled */
	Filled: 'Filled', //11,

	/** Order failed KYC check */
	KycIncomplete: 'KycIncomplete', //12,

	/** Invalid limit specified */
	LimitInvalid: 'LimitInvalid', //13,

	/** Invalid quantity specified */
	QuantityInvalid: 'QuantityInvalid', //14,

	/** Invalid account specified */
	AccountInvalid: 'AccountInvalid', //15,

	/** Invalid instrument specified */
	InstrumentInvalid: 'InstrumentInvalid', //16
};

export type OrderValidationEnum = typeof OrderValidationEnum[keyof typeof OrderValidationEnum];


export const OrgCompanyType = {
	Firm: 'Firm', //1,
	Fund: 'Fund', //2,
	Scheme: 'Scheme', //3,
	SBU: 'SBU', //4,
	SPV: 'SPV', //5,
};

export type OrgCompanyType = typeof OrgCompanyType[keyof typeof OrgCompanyType];


export const PartnerClass = {
	NONE: 'NONE', //0,
	//AGENT, //1,
	//BANK, //2,
	//BROKER, //3,
	CUSTOMER: 'CUSTOMER', //4,
	//REGISTRAR, //5,
	STAFF: 'STAFF', //6,
	VENDOR: 'VENDOR', //7,
	_3RD_PARTY: '_3RD_PARTY', //8,
	PATRON: 'PATRON', //9
};

export type PartnerClass = typeof PartnerClass[keyof typeof PartnerClass];


export const PartnerGlAcctTypes = {
	BondIncome: 'BondIncome', //11,
	Cash: 'Cash', //21,
	CurrencyFx: 'CurrencyFx', //26,
	DividendIncome: 'DividendIncome', //31,
	Expense: 'Expense', //41,
	FacilityInterest: 'FacilityInterest', //51,
	FacilityPrincipal: 'FacilityPrincipal', //56,
	LoanInterest: 'LoanInterest', //61,
	LoanPrincipal: 'LoanPrincipal', //66,
	MMInterestExpense: 'MMInterestExpense', //67,
	MMInterestIncome: 'MMInterestIncome', //68,
	MMPrincipal: 'MMPrincipal', //69,
	MMAccrual: 'MMAccrual', //70,
	TBillDiscount: 'TBillDiscount', //71,
	TBillIncome: 'TBillIncome', //76,
	WarehouseAgent: 'WarehouseAgent', //81,
	WarehouseVariation: 'WarehouseVariation', //86
};

export type PartnerGlAcctTypes = typeof PartnerGlAcctTypes[keyof typeof PartnerGlAcctTypes];


export const PartnerModeEnum = {
	Direct: 'Direct', //0,
	proXy: 'proXy', //1,
	Warehouse: 'Warehouse', //2,
};

export type PartnerModeEnum = typeof PartnerModeEnum[keyof typeof PartnerModeEnum];


export const PartnerOriginEnum = {
	NonResidentForeign: 'NonResidentForeign', //_NonResident | _Foreign, //2
	NonResidentLocal: 'NonResidentLocal', //_NonResident | _Local,
	ResidentForeign: 'ResidentForeign', //_Resident | _Foreign,
	ResidentLocal: 'ResidentLocal', //_Resident | _Local, //1
};

export type PartnerOriginEnum = typeof PartnerOriginEnum[keyof typeof PartnerOriginEnum];


export const PartnerStateFocused = {
	Discontinued: 'Discontinued', //-3,
	Inactive: 'Inactive', //-2,
	Pending: 'Pending', //-1,
	Reviewed: 'Reviewed', //0,
	Active: 'Active', //1
};

export type PartnerStateFocused = typeof PartnerStateFocused[keyof typeof PartnerStateFocused];


export const PartnerState = {
	Request_Discontinue: 'Request_Discontinue', //-103,
	Request_Deactivate: 'Request_Deactivate', //-102,
	Discontinued: 'Discontinued', //-3,
	Inactive: 'Inactive', //-2,
	Pending: 'Pending', //-1,
	Reviewed: 'Reviewed', //0,
	Active: 'Active', //1
};

export type PartnerState = typeof PartnerState[keyof typeof PartnerState];


export const PartnerTypeCodes = {
	Corporate: 'Corporate', //1,
	Fund: 'Fund', //2,
	Individual: 'Individual', //3,
	Own: 'Own', //4,
	PryIssue: 'PryIssue', //5,
	Trust: 'Trust', //6,
	//Warehouse: 'Warehouse', //7,
	//proXy: 'proXy', //8,
	JointAccount: 'JointAccount', //9,
	Admor: 'Admor', //10, //DeceasedExecutor
	Partnership: 'Partnership', //11,
	SchemeFoundation: 'SchemeFoundation', //12,
	SocAssocClubNGO: 'SocAssocClubNGO', //13,
	Custodian: 'Custodian', //14,
	Enterprise: 'Enterprise', //15,
	Nominee: 'Nominee', //16,
};

export type PartnerTypeCodes = typeof PartnerTypeCodes[keyof typeof PartnerTypeCodes];


export const PartnerXferType = {
	FROM: 'FROM', //-1,
	TO: 'TO', //1
};

export type PartnerXferType = typeof PartnerXferType[keyof typeof PartnerXferType];


export const PartnerWebClosure = {
    NoOp: 'NoOp', //-10000,
    ActivateValidate: 'ActivateValidate', //-102,
    ActivateRequest: 'ActivateRequest', //-101,
    Deactivated: 'Deactivated', //-100,
    UserNamePasswordValidate: 'UserNamePasswordValidate', //-23,
    UserPasswordResetRequest: 'UserPasswordResetRequest', //-22,
    UserNameRemindRequest: 'UserNameRemindRequest', //-21,
    UnlockValidate: 'UnlockValidate', //-12,
    UnlockRequest: 'UnlockRequest', //-11,
    Locked: 'Locked', //-10,
    IssueCheck: 'IssueCheck', //-2,
    Pending: 'Pending', //-1,
    Received: 'Received', //0,
    ConfirmValidate: 'ConfirmValidate', //1,
    Active: 'Active', //2
};

export type PartnerWebClosure = typeof PartnerWebClosure[keyof typeof PartnerWebClosure];


export const ProjectClosure = {
	Abandoned: 'Abandoned', //-10,
	Suspended: 'Suspended', //-2,
	Pending: 'Pending', //-1,
	Approved: 'Approved', //0,
	Pipeline: 'Pipeline', //1,
	SignOn: 'SignOn', //2,
	Running: 'Running', //3,
	Closed: 'Closed', //4
};

export type ProjectClosure = typeof ProjectClosure[keyof typeof ProjectClosure];


export const ReferenceDataClosure = {
	Deactivated: 'Deactivated', //-2,
	Unapproved: 'Unapproved', //-1,
	Active: 'Active', //0
};

export type ReferenceDataClosure = typeof ReferenceDataClosure[keyof typeof ReferenceDataClosure];


/**Enum showing the state of an FA Transaction*/
export const SimpleTermClosure = {
	Invalidated: 'Invalidated', //-10,
	Failed: 'Failed', //-5,
	Pending: 'Pending', //-1,
	Validating: 'Validating', //0,
	Approving: 'Approving', //2,
	Closed: 'Closed', //4, // => 0
	Running: 'Running', //7, // => 2
	Terminated: 'Terminated', //8
};

export type SimpleTermClosure = typeof SimpleTermClosure[keyof typeof SimpleTermClosure];


/**Enum showing the state of a TermInstrument*/
export const TermInstrumentClosure = {
    /**Indicates a TermInstrument that is untouchable*/
    Untouchable: 'Untouchable', //-100,
	/**Indicates a TermInstrument that is untouchable*/
	Discarded: 'Discarded', //-2,
    /**Indicates a TermInstrument that is Pending; it hasn't undergone any other processing*/
	Pending: 'Pending', //-1,

	FirstToReview: 'FirstToReview', //0,
	IntCtrlToReview: 'IntCtrlToReview', //1,
	MgtToApprove: 'MgtToApprove', //2,
	InitPending: 'InitPending', //3,

    /**Indicates a TermInstrument that has been Initialized and is running*/
    Running: 'Running', //4,
    /**Indicates a TermInstrument that has been Terminated*/
    Terminated: 'Terminated', //5,
    /**Indicates a TermInstrument that has been WrittenOff*/
    WrittenOff: 'WrittenOff', //6,
    /**Indicates a TermInstrument that has been RolledOver with Principal*/
    RolledOverPrin: 'RolledOverPrin', //7,
    /**Indicates a TermInstrument that has been RolledOver with Principal and Interest*/
	RolledOverPrinInt: 'RolledOverPrinInt', //8
};

export type TermInstrumentClosure = typeof TermInstrumentClosure[keyof typeof TermInstrumentClosure];


/**Enum to indicate the type of interest on term instruments*/
export const TermInterestType = {
	/**Indicates a TermInstrument with SimpleInterest computation*/
	Simple: 'Simple', //1,
	/**Indicates a TermInstrument Amortized over its life*/
	Amortized: 'Amortized', //2,
	/**Indicates a TermInstrument that is of the Annuity type*/
	Annuity: 'Annuity', //3,
	/**Indicates a TermInstrument whose interest is paid out as Coupons*/
	Coupon: 'Coupon', //4,
	/**Indicates a TermInstrument with CompoundInterest computation*/
	Compound: 'Compound', //5,
	/**Indicates a Discounted TermInstrument*/
	Discounted: 'Discounted', //6,
	/**Indicates a Bullet TermInstrument*/
	Bullet: 'Bullet', //7,
};

export type TermInterestType = typeof TermInterestType[keyof typeof TermInterestType];


/**Enum that indicates the type of TermPayment*/
export const TermPaymentType = {
	/**Indicates an increase in the principal value; interest is zero*/
	DRAWDOWN: 'DRAWDOWN', //1,
	/**Indicates a decrease in principal and/or interest*/
	PAYDOWN: 'PAYDOWN', //-1,
};

export type TermPaymentType = typeof TermPaymentType[keyof typeof TermPaymentType];


/**Enum that indicates the type of TermProvision*/
export const TermProvisionType = {
	/**Indicates an increase in the principal value; interest is zero*/
	PROVISION: 'PROVISION', //1,
	/**Indicates a decrease in principal and/or interest*/
	WRITEBACK: 'WRITEBACK', //-1,
};

export type TermProvisionType = typeof TermProvisionType[keyof typeof TermProvisionType];


/**Enum that shows the state of a transaction associated with a Term Instrument*/
export const TermTxnClosure = {
    /**Indicates a TermInstrumentPayment that is untouchable*/
    Untouchable: 'Untouchable', //-10,
    /**Indicates a TermInstrumentPayment that is Pending; it hasn't undergone any other processing*/
    Pending: 'Pending', //-1,
    /**Indicates a TermInstrumentPayment that has been Processed/Posted*/
    Processed: 'Processed', //0,
    /**Indicates a TermInstrumentPayment that is an Init entry; it's posting/reversal is done as part of the parent transaction*/
    InitEntry: 'InitEntry', //1,
    /**Indicates a TermInstrumentPayment that is a Terminal/Terminate entry; it's posting/reversal is done as part of the parent transaction*/
    TerminateEntry: 'TerminateEntry', //2
};

export type TermTxnClosure = typeof TermTxnClosure[keyof typeof TermTxnClosure];


export const TransactionSummary = {
	DAILY: 'DAILY', //0,
	WEEKLY: 'WEEKLY', //1,
	MONTHLY: 'MONTHLY', //2,
	QUARTERLY: 'QUARTERLY', //4,
	YEARLY: 'YEARLY', //8,
};

export type TransactionSummary = typeof TransactionSummary[keyof typeof TransactionSummary];

